import React from 'react';

import FlexBox from '../../../FlexBox/FlexBox';
import LoadingSpinner from '../../../loading/loading';

import css from './Loading.css';

const Loading: React.FC = () => (
    <FlexBox className={css.root} justify="center" align="center">
        <LoadingSpinner type="spinner" />
    </FlexBox>
);

export default Loading;
